export const TABLE_SELECT_TYPE = Symbol('select');
